import { combineReducers } from "@reduxjs/toolkit";
import { all } from "redux-saga/effects";
import parseUrlReducer from "./parseUrl";
import handleServiceReducer, { handleServiceSaga } from "./handleService";
import branchListReducer, { branchListSaga } from "./productSearch/branchList";
import productSearchReducer, {
  productSearchSaga,
} from "./productSearch/productSearch";
import bestSellerReducer, { bestSellerSaga } from "./productSearch/bestSeller";

import productDetailReducer, {
  productDetailSaga,
} from "./productSearch/productDetail";
import storeInfoReducer, { storeInfoSaga } from "./landing/storeInfo";
import storeStatusReducer, { storeStatusSaga } from "./landing/storeStatus";
import getSendbirdStatusReducer, {
  getSendbirdStatusSaga,
} from "./chat/agent/getSendbirdStatus";
import checkArsStatusReducer, {
  checkArsStatusSaga,
} from "./arsUrlValidator/checkArsStatus";
import connectChatServerReducer, {
  connectChatServerSaga,
} from "./chat/agent/connectChatServer";
import lostFoundReducer, { lostFoundSaga } from "./lostFound/lostFound";
import registerLostItemReducer, {
  registerLostItemSaga,
} from "./lostFound/registerLostItem";
import checkListedItemReducer, {
  checkListedItemSaga,
} from "./lostFound/checkListedItem";
import afterServiceAgentReducer, {
  afterServiceAgentSaga,
} from "./afterService/afterServiceAgent";
import qaReducer, { qaSaga } from "./chat/bot/qa";
import agreePrivacyReducer, {
  agreePrivacySaga,
} from "./agreePrivacyTerm/agreePrivacy";
import decryptPhoneNumberReducer, {
  decryptPhoneNumberSaga,
} from "./decryptPhoneNumber/decryptPhoneNumber";
import promotionReducer, { promotionSaga } from "./landing/promotion";
import quickMenuReducer, { quickMenuSaga } from "./landing/quickMenu";
import getBranchesReducer, { getBranchesSaga } from "./getBranches/getBranches";
import destinationReducer from "./destination/destination";
import initForNobrandReducer, {
  initForNobrandSaga,
} from "./chat/bot/initForNobrand";
import FAQReducer, { FAQSaga } from "./chat/bot/FAQ";
import ratingReducer, { ratingSaga } from "./chat/agent/rating";
import ticketCloseReducer, { ticketCloseSaga } from "./chat/agent/ticketClose";
import agreeProductReducer from "./productSearch/agreeProduct";
import storeNewsReducer, { storeNewsSaga } from "./storeNews/storeNews";
import getBranchesStoreNewsReducer, {
  getBranchesStoreNewsSaga,
} from "./storeNews/getBranchesStoreNews";
import getNoticeListReducer, {
  getNoticeListSaga,
} from "./notice/getNoticeList";
import noticeDetailReducer, { noticeDetailSaga } from "./notice/noticeDetail";
import eventsReducer, { eventsSaga } from "./events/events";
import fileUploadReducer from "./chat/agent/fileUpload";
import googleAnaliticsReducer from "./ga/googleAnalitics";
import checkAssignTimeReducer, {
  checkAssignTimeSaga,
} from "./chat/agent/checkAssignTime";
import sessionReducer from "./session/session";
import popUpSliderReducer from "./promotion/popUpSlider";
import serviceAlertReducer from "./serviceAlert/serviceAlert";
import checkChatStatusReducer, {
  checkChatStatusSaga,
} from "./arsUrlValidator/checkChatStatus";
import peerIpReducer, { peerIpSaga } from "./peerIp";
import maskedPhoneNumberReducer, { maskedPhoneNumberSaga } from "./lostFound/maskedPhoneNumber";
import gameScheduleReducer, { gameScheduleSaga } from "./landing/gameSchedule";

export function* rootSaga() {
  yield all([
    getSendbirdStatusSaga(),
    handleServiceSaga(),
    branchListSaga(),
    productSearchSaga(),
    bestSellerSaga(),
    productDetailSaga(),
    storeInfoSaga(),
    storeStatusSaga(),
    checkArsStatusSaga(),
    connectChatServerSaga(),
    lostFoundSaga(),
    agreePrivacySaga(),
    registerLostItemSaga(),
    checkListedItemSaga(),
    afterServiceAgentSaga(),
    qaSaga(),
    decryptPhoneNumberSaga(),
    promotionSaga(),
    quickMenuSaga(),
    getBranchesSaga(),
    initForNobrandSaga(),
    FAQSaga(),
    ratingSaga(),
    ticketCloseSaga(),
    storeNewsSaga(),
    getBranchesStoreNewsSaga(),
    getNoticeListSaga(),
    noticeDetailSaga(),
    eventsSaga(),
    checkAssignTimeSaga(),
    checkChatStatusSaga(),
    peerIpSaga(),
    maskedPhoneNumberSaga(),
    gameScheduleSaga(),
  ]);
}

const rootReducer = combineReducers({
  parseUrl: parseUrlReducer,
  getSendbirdStatus: getSendbirdStatusReducer,
  handleService: handleServiceReducer,
  branchList: branchListReducer,
  productSearch: productSearchReducer,
  bestSeller: bestSellerReducer,
  productDetail: productDetailReducer,
  storeInfo: storeInfoReducer,
  storeStatus: storeStatusReducer,
  checkArsStatus: checkArsStatusReducer,
  connectChatServer: connectChatServerReducer,
  lostFound: lostFoundReducer,
  agreePrivacy: agreePrivacyReducer,
  registerLostItem: registerLostItemReducer,
  checkListedItem: checkListedItemReducer,
  afterServiceAgent: afterServiceAgentReducer,
  qa: qaReducer,
  decryptPhoneNumber: decryptPhoneNumberReducer,
  promotion: promotionReducer,
  quickMenu: quickMenuReducer,
  getBranches: getBranchesReducer,
  destination: destinationReducer,
  initForNobrand: initForNobrandReducer,
  FAQ: FAQReducer,
  rating: ratingReducer,
  ticketClose: ticketCloseReducer,
  agreeProduct: agreeProductReducer,
  storeNews: storeNewsReducer,
  getBranchesStoreNews: getBranchesStoreNewsReducer,
  getNoticeList: getNoticeListReducer,
  noticeDetail: noticeDetailReducer,
  events: eventsReducer,
  fileUpload: fileUploadReducer,
  googleAnalitics: googleAnaliticsReducer,
  checkAssignTime: checkAssignTimeReducer,
  session: sessionReducer,
  popUpSlider: popUpSliderReducer,
  serviceAlert: serviceAlertReducer,
  checkChatStatus: checkChatStatusReducer,
  peerIp: peerIpReducer,
  maskedPhoneNumber: maskedPhoneNumberReducer,
  gameSchedule: gameScheduleReducer,
});

export default rootReducer;
